/**
 * Firebase Configuration
 * Shared configuration for authentication and Firestore
 */

const firebaseConfig = {
  apiKey: "AIzaSyDiGB1gIisdXK2f2FbFYv5mycFy2P9ea4k",
  authDomain: "findplayers-7aa6d.firebaseapp.com",
  projectId: "findplayers-7aa6d",
  storageBucket: "findplayers-7aa6d.appspot.com",
  messagingSenderId: "896872569838",
  appId: "1:896872569838:web:018a8f2fb2efb565744cff",
  measurementId: "G-ESYW9SWXWL"
};

export default firebaseConfig;
